import dataplus from '@lcsc/data-plus';

import { env } from '@/utils/baseUrl';
import Utils from '@/utils/Utils';

const pid = Utils.getUuid();
export const getBuriedPointCP = () => {
  const host = location.host;
  const pathname = location.pathname;
  let cp = document?.body?.dataset?.cp || 'keyword_search';
  if (/www\.szlcsc\.com/.test(host) || /www-next\.szlcsc\.com/.test(host)) {
    cp = 'index';
    if (pathname.startsWith('/selection')) {
      cp = 'selection_detail';
    }
    if (pathname.startsWith('/mkt')) {
      cp = 'tail_seo';
    }
  } else if (/item(-next)?\.szlcsc\.com/.test(host) || /item-next\.szlcsc\.com/.test(host)) {
    cp = 'product_detail';
  } else if (/activity(-next)?\.szlcsc\.com/.test(host)) {
    cp = 'activity';
  }
  return cp;
};
export const buriedPoint = (op) => {
  const data = {
    pf: 'pc',
    cp: getBuriedPointCP(),
    ty: 'click',
    pid,
    ...op,
  };
  // start 搜索埋点特殊处理
  let rsLog = localStorage.getItem('rsLog') || '';
  if (data?.data?.rs_log) {
    rsLog = data.data.rs_log;
  }
  if (rsLog) {
    const rsLogData = JSON.parse(rsLog);
    if (data.data) {
      data.data = Object.assign({}, rsLogData, data.data);
    } else {
      data.data = Object.assign({}, rsLogData);
    }
  }
  if (data?.data?.rs_uid) {
    const option = window.isMro ? 'MRO' : sessionStorage.getItem('main-site-search-option');
    data.data.option = option;
  }
  if (data?.data?.rs_log) {
    delete data.data.rs_log;
  }
  // end
  if (env !== 'local') {
    dataplus.report(data);
  } else {
    console.log('埋点信息', data);
  }
};

export const headBuriedPoint = (op, href, ty) => {
  const current_h = window.location.href;
  const cp = ['DRAG_BOM_FILES', 'BOM_UPLOAD_FILES'].includes(op) ? 'BOM_UPLOAD_INDEX' : 'top_header';
  if (href) {
    buriedPoint({
      cp,
      ty: ty || 'click',
      op,
      data: { hf: href, current_href: current_h },
    });
  } else {
    buriedPoint({ cp, ty: ty || 'click', op });
  }
};
export const getNavPoint = (name, href) => {
  let flag;
  const needBuriedPoints = {
    首页: 'Home_page',
    PLUS会员: 'plus',
    立创ERP: 'erp',
    立创商城: 'lcsc',
    行家精选: 'selected_products',
    兑换中心: 'exchange_center',
    入驻商城: 'vendor_union',
    'PCB/SMT': 'go_industry',
  };
  if (name === '商城首页' || href === 'https://www.szlcsc.com') {
    flag = 'mall_homepage';
  } else if (name === '商品目录' || href === 'https://www.szlcsc.com/catalog.html') {
    flag = 'product_catalogue';
  } else if (name === '爆款抢购' || name === '爆款推荐' || href === 'https://list.szlcsc.com/hot') {
    flag = 'hot_product';
  } else if (name === '超值折扣') {
    flag = 'discount_product';
  } else if (name === '领券中心' || href === 'https://www.szlcsc.com/huodong.html') {
    flag = 'coupon_center';
  } else if (name === '海外代购' || href === 'https://www.szlcsc.com/oversea/intro.html') {
    flag = 'overseas_shopping';
  } else if (name === '兑换专区' || href === 'https://activity.szlcsc.com/point/use/info.html') {
    flag = 'points_mall';
  } else if (name === '免费入驻' || href === 'https://www.szlcsc.com/supplier/convass.html') {
    flag = 'free_entry';
  } else if (name === 'BOM配单' || href === 'https://bom.szlcsc.com/bom.html') {
    flag = 'BOM_pairing';
  } else if (name === '品牌库' || href === 'https://www.szlcsc.com/brand.html') {
    flag = 'brand_library';
  } else if (name === '备货找料' || href.includes('https://www.szlcsc.com/stock.html')) {
    flag = 'BEIHUO';
  } else if (name === '立推专区') {
    flag = 'LITUI';
  } else if (name === '工业品' || href === 'https://mro.szlcsc.com') {
    flag = 'MRO';
  } else if (name === '面板打印' || href.includes('https://dos.szlcsc.com/home.html')) {
    flag = 'MBDY';
  } else {
    flag = needBuriedPoints[name];
  }
  if (flag) {
    headBuriedPoint(flag, href);
  }
  if (name === '工业品MRO') {
    const current_h = window.location.href;
    buriedPoint({
      cp: 'top_header',
      ty: 'click',
      op: 'mro_zone',
      data: { hf: href, current_href: current_h },
    });
  }
};

// 商品跳转详情页统一埋点处理
// pid-自营商品id
// kind--类型：name表示点击的名称, picture表示点击的图片
// track_zone 搜索标识
// type 供应商 海外代购专属
// ix 所在类别的排序
// cp 当前页
// kw 搜索词
export function goItemBuriedPoint({ ix, pc, type, track_zone, ...params }) {
  // 用户行为分析埋点
  const data = { ...params };
  if (pc) {
    data.pc = pc;
  }
  if (type) {
    data.type = type;
  }
  if (track_zone) {
    data.track_zone = track_zone;
  }
  if (ix) {
    data.ix = ix;
  }
  const option = window.isMro ? 'MRO' : sessionStorage.getItem('main-site-search-option');
  if (option) {
    data.option = option;
  }
  buriedPoint({ op: 'go_detail', data });
}
